"use client";

import React, { useState } from "react";
import Image from "next/image";
import CircularProgress from "@mui/material/CircularProgress";
import s from "../styles.parts";
import Consts from "@common/config/consts";
import { utils } from "@lib/client";
import { usePartsList } from "../usePartsList";

import logjs from "@metrojs/logjs";
const log = new logjs("AddPartsListArea");

export default function AddPartsListArea({
  data,
  quote_number,
  state,
  actions,
  form: parentForm,
  formProps: parentFormProps,

  addPartsdata,
  setAddPartsData,
  photoDialogProps,
  fileupDialogProps,
  qaDialogProps,
}) {
  // フォーム管理フックの使用
  const initState = {
    sbunrui: null,
    sbui: null,
    parts4cd: null,
  };
  const [form, formProps] = usePartsList(initState, state, actions);
  const { IsLoading } = state;
  const [isShowAddPartsArea, setIsShowAddPartsArea] = useState(true);
  const [sbui, setSbui] = useState("-1"); // 中カテゴリ
  const [sbuiList, setSbuiList] = useState(Consts.NOT_SELECT_OPTIONS.concat([])); // 中カテゴリリスト
  const [parts4cd, setParts4cd] = useState("-1"); // 部品名
  const [parts4cdList, setParts4cdList] = useState(Consts.NOT_SELECT_OPTIONS.concat([])); // 部品名リスト

  const onChangeAddParts = (index, field, value) => {
    addPartsdata[index][field] = value;
    setAddPartsData([...addPartsdata]);
  };
  const hasAddPartsPhoto = data?.hasAddPartsPhoto;

  const handleAddBikou = (i, j) => {
    const selectId = `hselect_${i}_${j}`;
    const textareaId = `biko_${i}_${j}`;
    const select = document.getElementById(selectId);
    const textarea = document.getElementById(textareaId);
    if (select && textarea) {
      const selectedValue = select.value;
      textarea.value = (textarea.value || "") + selectedValue;
    }
  };
  return (
    <s.AddPartsSection>
      <s.PartsTitle>
        <s.FlexBetween>
          <s.FlexRow>
            <div style={{ marginRight: "4px" }}>追加商品情報入力</div>
            <s.QuestionButton
              style={{ verticalAlign: "middle", marginTop: "-5px" }}
              onClick={(e) => {
                e.preventDefault();
                qaDialogProps.open({ MitsumoriNo: quote_number, isQuestion: ( state.user?.Gyoshu_flg === 1) });
              }}
            >
              依頼元へ質問を行う | 回答を見る
            </s.QuestionButton>
          </s.FlexRow>
          <s.ToggleButton
            // href="javascript:void(0)"
            onClick={() => {
              setIsShowAddPartsArea(!isShowAddPartsArea);
            }}
          >
            {isShowAddPartsArea ? "▲追加部品情報入力をする" : "▼追加部品情報入力をする"}
          </s.ToggleButton>
        </s.FlexBetween>
      </s.PartsTitle>

      {isShowAddPartsArea && (
        <s.AddPartsArea>
          {/* カテゴリ選択テーブル */}
          <s.CategorySelectTable>
            <tbody>
              <tr>
                <s.CategorySelectHeader>
                  <s.StepText>ステップ1：大カテゴリ</s.StepText>
                </s.CategorySelectHeader>
                <s.CategorySelectHeader></s.CategorySelectHeader>
                <s.CategorySelectHeader>
                  <s.StepText>ステップ2：中カテゴリ</s.StepText>
                </s.CategorySelectHeader>
                <s.CategorySelectHeader></s.CategorySelectHeader>
                <s.CategorySelectHeader>
                  <s.StepText>ステップ3：部品名</s.StepText>
                </s.CategorySelectHeader>
                <s.CategorySelectHeader>&nbsp;</s.CategorySelectHeader>
              </tr>
              <tr>
                <s.CategorySelectCell style={{ textAlign: "center", width: "25%" }}>
                  {formProps.select_sbunrui({
                    style: { ...Consts.BASE_STYLE.SELECT, width: "90%" },
                    after_func: async (_f) => {
                      setSbui("-1");
                      setParts4cd("-1");
                      setSbuiList(Consts.NOT_SELECT_OPTIONS.concat([]));

                      const result = await formProps.getBuiByBunruiCd(_f.sbunrui);
                      if (result != null && result.data && result.data.length > 0) {
                        setSbuiList(Consts.NOT_SELECT_OPTIONS.concat(result.data));
                        setParts4cdList(Consts.NOT_SELECT_OPTIONS.concat([]));
                      } else {
                        setSbuiList([]);
                        const result = await formProps.getBuhinByBuiCd(Number(_f.sbunrui));
                        log.debug("getBuhinByBuiCd", result);
                        if (result != null && result.data && result.data.length > 0) {
                          setParts4cdList(Consts.NOT_SELECT_OPTIONS.concat(result.data));
                        } else {
                          setParts4cdList(Consts.NOT_SELECT_OPTIONS.concat([]));
                        }
                      }
                    },
                  })}
                </s.CategorySelectCell>
                <s.CategorySelectCell style={{ textAlign: "center", width: "5%" }}>
                  <s.ArrowText>→</s.ArrowText>
                </s.CategorySelectCell>
                <s.CategorySelectCell style={{ textAlign: "center", width: "25%" }}>
                  {IsLoading ? (
                    <CircularProgress size={24} />
                  ) : (
                    sbuiList.length > 0 &&
                    formProps.select("sbui", {
                      value: sbui,
                      style: { ...Consts.BASE_STYLE.SELECT, width: "90%" },
                      options: sbuiList,
                      is_standard: true,
                      after_func: async (_f) => {
                        setSbui(Number(_f.sbui));
                        setParts4cd("-1");
                        //setParts4cdList(Consts.NOT_SELECT_OPTIONS.concat([]));
                        const result = await formProps.getBuhinByBuiCd(Number(_f.sbui));
                        log.debug("getBuhinByBuiCd", result);
                        if (result != null && result.data && result.data.length > 0) {
                          setParts4cdList(Consts.NOT_SELECT_OPTIONS.concat(result.data));
                        } else {
                          setParts4cdList(Consts.NOT_SELECT_OPTIONS.concat([]));
                        }
                      },
                    })
                  )}
                </s.CategorySelectCell>
                <s.CategorySelectCell style={{ textAlign: "center", width: "5%" }}>
                  <s.ArrowText>→</s.ArrowText>
                </s.CategorySelectCell>
                <s.CategorySelectCell style={{ textAlign: "center", width: "25%" }}>
                  {IsLoading ? (
                    <CircularProgress size={24} />
                  ) : (
                    formProps.select("parts4cd", {
                      id: `parts4cd`,
                      value: parts4cd,
                      style: { ...Consts.BASE_STYLE.SELECT, width: "90%" },
                      is_standard: true,
                      options: parts4cdList,
                      after_func: async (_f) => {
                        setParts4cd(String(_f.parts4cd));
                      },
                    })
                  )}
                </s.CategorySelectCell>
                <s.CategorySelectCell style={{ width: "15%", textAlign: "center" }}>
                  <s.RegisterButton
                    // href="javascript:void(0)"
                    onClick={async (e) => {
                      e.preventDefault();
                      log.debug("---form", form);
                      const isBunrui = !utils.isNull(form?.sbunrui);
                      const isBui = !utils.isNull(form?.sbui);
                      const isParts4cd = !utils.isNull(form?.parts4cd);
                      /*
                      if (isBunrui == false) {
                        actions.showAlert("大カテゴリを選択してください。");
                        return;
                      }
                      if (isBui == false) {
                        actions.showAlert("中カテゴリを選択してください。");
                        return;
                      }
                      */
                      if (isParts4cd == false) {
                        actions.showAlert("部品名を選択してください。");
                        return;
                      }

                      log.debug("addPartsdata", addPartsdata);
                      // 重複登録チェック
                      for (const _row of addPartsdata) {
                        if (_row.selectedBunrui === form.sbunrui && _row.selectedBui === form.sbui && _row.selectedParts === form.parts4cd) {
                          actions.showAlert("既に選択されています。");
                          return;
                        }
                      }
                      log.debug(`form form.parts4cd:${form.parts4cd} form.sbunrui:${form.sbunrui} form.sbui:${form.sbui} parts4cdList:`, parts4cdList);
                      const newAddPartsData = {
                        selectedBunrui: form.sbunrui,
                        Bunrui: form.sbunrui,
                        selectedBui: form.sbui,
                        selectedParts: form.parts4cd,
                        OthPartsName: parts4cdList.find((item) => String(item.value) === String(form.parts4cd))?.label || "",
                        PartsJyunseiCode: "",
                        PartsKindID: "",
                        StanderdPrice: "",
                        Soryo: "",
                        Hasso: "",
                        Sell_Limit: "",
                        ColorNo: "",
                        ColorName: "",
                      };
                      log.debug("newAddPartsData", newAddPartsData);
                      setAddPartsData([...addPartsdata, newAddPartsData]);
                    }}
                  >
                    登録
                  </s.RegisterButton>
                </s.CategorySelectCell>
              </tr>
            </tbody>
          </s.CategorySelectTable>

          {/* 追加商品情報テーブル */}
          <s.AddPartsTable>
            <tbody>
              {addPartsdata && addPartsdata.length > 0
                ? addPartsdata.map((addPartsItem, index) => (
                    <React.Fragment key={`addPartsItem-${index}`}>
                      {/* 追加商品名ヘッダー行 */}
                      <tr>
                        <s.AddPartsNameHeader colSpan="13">
                          {addPartsItem.OthPartsName}
                          {/* @TODO 要チェック */}
                          {addPartsItem?.selectedParts && addPartsItem?.selectedParts.substr(-3) === "990" && <>品名：{formProps.input_OthPartsSonota()}</>}
                        </s.AddPartsNameHeader>
                      </tr>

                      {/* ヘッダー行 */}
                      <tr>
                        <s.AddPartsHeader scope="row">純正品番</s.AddPartsHeader>
                        <s.AddPartsHeader>数量</s.AddPartsHeader>
                        <s.AddPartsHeader>
                          <div>部品カテゴリ</div>
                          <s.RequiredMark src="/images/must.png" alt="必須" />
                        </s.AddPartsHeader>
                        <s.AddPartsHeader>
                          <div>価格(税別)</div>
                          <s.RequiredMark src="/images/must.png" alt="必須" />
                        </s.AddPartsHeader>
                        <s.AddPartsHeader>
                          <div>送料(税別)</div>
                          <s.RequiredMark src="/images/must.png" alt="必須" />
                        </s.AddPartsHeader>
                        <s.AddPartsHeader>
                          <div>発送可能日</div>
                          <s.RequiredMark src="/images/must.png" alt="必須" />
                        </s.AddPartsHeader>
                        <s.AddPartsHeader>
                          <div>見積有効期限</div>
                          <s.RequiredMark src="/images/must.png" alt="必須" />
                        </s.AddPartsHeader>
                        <s.AddPartsHeader>カラー番号</s.AddPartsHeader>
                        <s.AddPartsHeader>カラー名称</s.AddPartsHeader>
                        <s.AddPartsHeader>写真</s.AddPartsHeader>
                      </tr>

                      {/* 入力行 */}
                      <tr>
                        <td scope="row">
                          {formProps.input_PartsJyunseiCode({
                            value: addPartsItem?.PartsJyunseiCode || "",
                            style: { width: "10em" },
                            onChange: (e, params) => {
                              onChangeAddParts(index, "PartsJyunseiCode", e.target.value);
                            },
                          })}
                        </td>
                        <td style={{ width: "3em" }}>1</td>
                        <td>
                          {formProps.select_PartsKindID({
                            value: addPartsItem?.PartsKindID || "",
                            style: { width: "10em" },
                            onChange: (e, params) => {
                              onChangeAddParts(index, "PartsKindID", e.target.value);
                            },
                          })}
                        </td>
                        <td>
                          {formProps.input_StanderdPrice({
                            value: addPartsItem?.StanderdPrice || "",
                            style: { width: "10em" },
                            onChange: (e, params) => {
                              onChangeAddParts(index, "StanderdPrice", e.target.value);
                            },
                          })}
                        </td>
                        <td>
                          {formProps.input_Soryo({
                            value: addPartsItem?.Soryo || "",
                            style: { width: "10em" },
                            onChange: (e, params) => {
                              onChangeAddParts(index, "Soryo", e.target.value);
                            },
                          })}
                        </td>
                        <td>
                          {formProps.select_Hasso({
                            value: addPartsItem?.Hasso || "",
                            style: { width: "10em" },
                            onChange: (e, params) => {
                              onChangeAddParts(index, "Hasso", e.target.value);
                            },
                          })}
                        </td>
                        <td>
                          {formProps.datePicker_Sell_Limit({
                            value: addPartsItem?.Sell_Limit || "",
                            style: { width: "10em" },
                            onChange: (value, params) => {
                              onChangeAddParts(index, "Sell_Limit", value);
                            },
                          })}
                        </td>
                        <td>
                          {formProps.input_ColorNo({
                            value: addPartsItem?.ColorNo || "",
                            style: { width: "10em" },
                            onChange: (e, params) => {
                              onChangeAddParts(index, "ColorNo", e.target.value);
                            },
                          })}
                        </td>
                        <td>
                          {formProps.input_ColorName({
                            value: addPartsItem?.ColorName || "",
                            style: { width: "10em" },
                            onChange: (e, params) => {
                              onChangeAddParts(index, "ColorName", e.target.value);
                            },
                          })}
                        </td>
                        <td>
                          <s.FlexRow style={{ width: "100%", justifyContent: "center", textAlign: "center", alignItems: "center", gap: "10px" }}>
                            <a
                              onClick={formProps.handlePhotoClick(
                                photoDialogProps,
                                quote_number,
                                0,
                                addPartsItem?.Seqnum ?? index + 1,
                                Consts.WRECKER_PHOTO.KARI_WRT,
                                addPartsItem?.OthPartsName,
                              )}
                              style={{ cursor: "pointer" }}
                            >
                              <Image src={"/images/camera_icon.png"} alt="写真" width={24} height={20} />
                            </a>
                            <a
                              onClick={formProps.handleFileupClick(
                                fileupDialogProps,
                                quote_number,
                                0,
                                addPartsItem?.Seqnum ?? index + 1,
                                Consts.WRECKER_PHOTO.KARI_WRT,
                                addPartsItem?.OthPartsName,
                              )}
                              style={{ cursor: "pointer" }}
                            >
                              <Image src="/images/file_icon.png" alt="ファイル" width={20} height={24} />
                            </a>
                          </s.FlexRow>
                        </td>
                      </tr>

                      {/* 部品備考・自社管理番号行 */}
                      <s.PartsConfirmTableHeader2Tr>
                        <s.PartsConfirmTableHeader2Th colSpan="9">部品備考</s.PartsConfirmTableHeader2Th>
                        <s.PartsConfirmTableHeader2Th scope="row">自社管理番号</s.PartsConfirmTableHeader2Th>
                      </s.PartsConfirmTableHeader2Tr>
                      <tr>
                        <td colSpan="9" style={{ textAlign: "left" }}>
                          {/* 保証選択 */}
                          {data?.hoshoSelect && data.hoshoSelect.length > 0 && (
                            <>
                              <select name={`data[Answer][${index}][0][HoshoSelect]`} id={`hselect_${index}_0`}>
                                {data.hoshoSelect.map((hs, idx) => (
                                  <option key={`${hs}-${idx}`} value={hs}>
                                    {hs}
                                  </option>
                                ))}
                              </select>

                              <input type="button" className="AddBikou" data-slt={`${index}_0`} value="追加" onClick={() => handleAddBikou(index, 0)} />
                              <br />
                            </>
                          )}
                          {/* 部品備考textarea */}
                          {formProps.input_Bikou({
                            value: addPartsItem?.Bikou || "",
                            style: { width: "95%", height: "60px" },
                            onChange: (e, params) => {
                              onChangeAddParts(index, "Bikou", e.target.value);
                            },
                          })}
                        </td>
                        <td scope="row" style={{ backgroundColor: "#FDF5E6" }}>
                          {/* 自社管理番号 */}
                          {formProps.input_JishaNo({
                            value: addPartsItem?.JishaNo || "",
                            style: { width: "10em" },
                            onChange: (e, params) => {
                              onChangeAddParts(index, "JishaNo", e.target.value);
                            },
                          })}
                          <br />
                          {/* PrepKindラジオボタン */}
                          {formProps.radio_PrepKind({
                            value: addPartsItem?.PrepKind || "",
                            style: { cursor: "pointer" },
                            name: `${index}_${addPartsItem?.PRID}_PrepKind`,
                            onChange: (e, params) => {
                              if (addPartsItem?.PrepKind !== e.target.value) {
                                onChangeAddParts(index, "PrepKind", e.target.value);
                              } else {
                                // 同じ値が選択された場合は空文字列にする
                                onChangeAddParts(index, "PrepKind", "");
                              }
                            },
                          })}
                        </td>
                      </tr>
                    </React.Fragment>
                  ))
                : null}
            </tbody>
          </s.AddPartsTable>
        </s.AddPartsArea>
      )}
    </s.AddPartsSection>
  );
}
